import CustomSectionDetails from "./CustomSectionDetails";

export default CustomSectionDetails;
